module.exports = __webpack_public_path__ + "static/media/mo.4fe6113a.svg";